<template>
  <div>
    <v-progress-linear
      color="deep-purple accent-4"
      indeterminate
      height="6"
      v-if="loading"
    ></v-progress-linear>
    <v-container>
      <v-row>
        <v-col
          v-for="product in products"
          :key="product.id"
          cols="12"
          sm="6"
          lg="4"
        >
          <v-card class="mt-3 mb-3 mx-auto" outlined :elevation="3">
            <v-img
              height="350"
              :src="product.images[0].src"
              alt="product.name"
              v-if="product.images.length > 0"
              class="black"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <v-list-item three-line>
              <v-list-item-content>
                <div>
                  <v-btn
                    :href="
                      url + '/categoria-producto/' + product.categories[0].slug
                    "
                    target="_blank"
                    text
                  >
                    <span class="overline">
                      {{ product.categories[0].name }}
                    </span>
                  </v-btn>
                </div>
                <a :href="url + '/producto/' + product.slug" target="_blank">
                  <v-list-item-title class="headline ml-1 mb-1">
                    {{ product.name }}
                  </v-list-item-title>
                </a>
                <Variations :variations="product.variations" />
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
      <v-progress-linear
        color="deep-purple accent-4"
        indeterminate
        height="6"
        v-if="loading"
      ></v-progress-linear>
      <v-btn
        class="my-2"
        :loading="loading"
        :disabled="loading || noMore"
        color="blue"
        @click="loadMore"
        block
        dark
      >
        Cargar más
      </v-btn>
    </v-container>
  </div>
</template>

<script>
import Variations from "./Variations.vue";
// TODO: mover api a un servicio aparte
import WooCommerceRestApi from "@woocommerce/woocommerce-rest-api";

const url = "https://jupiterstyle.ar";

const api = new WooCommerceRestApi({
  url: url,
  consumerKey: "ck_40a12a47900bed48082e3fc3aec96967147098e9",
  consumerSecret: "cs_aef93fb621ed3a28a91a15fe87eef769a04901f9",
  version: "wc/v3",
  axiosConfig: { headers: {} },
});

export default {
  name: "Products",
  components: {
    Variations,
  },
  data: () => ({
    url: url,
    products: [],
    page: 1,
    per_page: 10,
    noMore: false,
    loading: false,
  }),
  created() {
    this.getProducts();
  },
  methods: {
    async loadMore() {
      this.page += 1;
      this.getProducts();
    },
    async getProducts() {
      this.loading = true;
      let products;
      try {
        products = await api.get("products", {
          page: this.page,
          per_page: this.per_page,
        });
      } catch (error) {
        console.log(error);
        this.loading = false;
        return;
      }
      if (products.data.length < this.per_page) this.noMore = true;
      let ps = [...products.data];
      for (let i = 0; i < ps.length; i++) {
        let p = ps[i];
        ps[i].variations = await this.getVariations(p.id);
        ps[i].active = true;
      }
      this.products = [...this.products, ...ps];
      this.loading = false;
    },
    async getVariations(id) {
      try {
        const variations = await api.get(`products/${id}/variations`, {
          per_page: "100",
        });
        return variations.data;
      } catch (error) {
        console.log(error);
        return [];
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
